// chatSyncService.js
// Background service for syncing chat data to IndexedDB after login

import { getChatgroups } from "../common/Helper";
import { saveChatsToIndexedDB } from "../db";

/**
 * Background sync chat list to IndexedDB (non-blocking)
 * This runs after successful login without blocking the UI
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} loginData - User login data
 */
export const syncChatsToIndexedDB = async (dispatch, loginData) => {
  try {
    // Fetch chat list from API
    const chatList = await getChatgroups(dispatch, loginData);

    if (chatList && chatList?.length > 0) {
      // Prepare chat objects for IndexedDB
      const chatsToStore = chatList?.map((chat) => ({
        ...chat,
        lastMessageTime: new Date(chat?.dateSent).getTime(), // For sorting
        unreadMessagesNr: chat?.unreadMessagesNr || 0,
        muted: chat?.muted || false
      }));
      // Save to IndexedDB
      await saveChatsToIndexedDB(chatsToStore);
    } else {
      console.log("ℹ️ No chats to sync");
    }
  } catch (error) {
    console.error("❌ Error syncing chats to IndexedDB:", error);
  }
};
